module.exports = __webpack_public_path__ + "img/half-banner-bk.79ae009.png";